import { useCurrentCompany, useIsBizyEnabledForUser } from '@bonusly/who-am-i';

import { useBizyOnboarding } from '../../queries/bizy-onboarding';
import { useUserContentDismissal } from '../profile/user-content-dismissal';
import { MEET_BIZY_PROMO_NAME, MEET_BIZY_PROMO_NAMESPACE } from './meet-bizy-promo-constants';

/**
 * True while the Bizy intro takeover is still waiting to be shown, so the
 * Bizy side panel doesn't auto-open behind it. The takeover is the onboarding
 * flow (`<BizyOnboarding>` — additionally gated on onboarding never having
 * started). Both share the same dismissal record.
 */
export const useHasPendingMeetBizyPromo = () => {
	const isBizyEnabledForUser = useIsBizyEnabledForUser();
	const company = useCurrentCompany();
	const isEligible = isBizyEnabledForUser && !company?.isTrial;
	const { loading, data } = useUserContentDismissal({
		namespace: MEET_BIZY_PROMO_NAMESPACE,
		name: MEET_BIZY_PROMO_NAME,
		enabled: isEligible,
	});
	const { data: onboarding, isLoading: isOnboardingLoading } = useBizyOnboarding(isEligible);

	if (!isEligible) return false;
	// Wait for the dismissal record first — once we know the user dismissed,
	// the onboarding query result is irrelevant (the takeover won't show either way).
	if (loading) return true;
	if (data?.dismissed_at) return false;
	// Wait for the stage to decide, but if the query failed (data undefined
	// after loading) don't hold the panel hostage — the takeover can't open
	// either, so let the side panel auto-open.
	if (isOnboardingLoading) return true;
	// Onboarding already started (or finished, or the query failed) — the
	// takeover no longer auto-opens.
	return onboarding !== undefined && onboarding.onboardingStage === 0;
};
